import { Outlet } from 'react-router-dom';
import VendorDashboardLayout from '../../components/layouts/VendorDashboardLayout';
import BottomNav from '../../components/layouts/Footer/BottomNav';

const PublicLayoutRoute = () => {
  // This is a public route wrapper that uses VendorDashboardLayout
  // but without authentication protection
  return (
    <>
      <VendorDashboardLayout>
        <Outlet />
      </VendorDashboardLayout>
      <BottomNav />
    </>
  );
};

export default PublicLayoutRoute;
